import * as actions from "../actions";

export const getSingleVesselVesselDetailsApi = (id, data) =>
  actions.getSingleVesselVesselDetails(id, data);

export const updateVesselVesselDetailsApi = (id, data) =>
  actions.updateVesselVesselDetails(id, data);

export const addCargoDetailsApi = (data) =>
  actions.addCargoDetails(data);

export const deleteCargoExtraDetailVesselVesselApi = (data) =>
  actions.deleteCargoExtraDetailVesselVessel(data);

export const getPortDistanceVesselVesselByPortListApi = (data) =>
  actions.getPortDistanceVesselVesselByPortList(data);

export const sendCalculatorDataApi = (data) =>
  actions.sendCalculatorData(data);

export const resetDistanceApi = (data) =>
  actions.resetDistance(data);

export const savePortDistanceApi = (data) =>
  actions.savePortDistance(data);

export const allFleetCalculatorApi = (data) =>
  actions.allFleetCalculator(data);
